import React from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { updateSelectVariable } from "../../../../../store/reducers/pdfeditor/toolsModificationSlice";
import { updateCoordinate } from "../../../../../store/reducers/pdfeditor/pdfCoordinatesSlice";

const FontSize = () => {
  const dispatch = useDispatch();
  const { fontSize, currVariable } = useSelector(
    (state) => state.toolsModification
  );
  const handleChangeFontSize = (e) => {
    let value = Number(e.target.value);
    console.log('inside font size only...', value)
    let data = { fontSize: value };
    if (value >= 0 && value < 25 && !currVariable?.variable) {
      dispatch(updateSelectVariable(data));
    } else if (value >= 0 && value < 25) {
      dispatch(updateSelectVariable(data));
      dispatch(
        updateCoordinate({ id: currVariable?.variable, newValue: data })
      );
    } 
  };

  const handleKeyPress = (e) => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
      let newValue = fontSize;
      if (e.key === "ArrowUp") {
        newValue = Math.min(newValue + 1, 24);
      } else if (e.key === "ArrowDown") {
        newValue = Math.max(newValue - 1, 0);
      }

      let data = { fontSize: newValue };
      if (!currVariable?.variable) {
        dispatch(updateSelectVariable(data));
      } else {
        dispatch(updateSelectVariable(data));
        dispatch(
          updateCoordinate({ id: currVariable?.variable, newValue: data })
        );
      }
    }
  };

  return (
    <Wrapper>
      <div style={{ display: "flex", alignItems: "center", width: "90px" }}>
        <p>Font Size</p>
        <input
          value={fontSize}
          onChange={handleChangeFontSize}
          style={inputStyle}
          disabled={currVariable?.data_type === "image"}
          onKeyDown={handleKeyPress}
        />
      </div>
    </Wrapper>
  );
};

export default FontSize;
const inputStyle = {
  width: "100%",
  height: "25px",
};
const Wrapper = styled.div`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .size-display {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 22%;
  }
  p {
    font-size: 12px;
    margin-right: 5px;
    white-space: nowrap;
  }
`;
